// Global Instructions Rule Applied!
//
// Fund full-form Interest Accruals tab: embeds the Interest Accruals
// workbench with the fund fixed (the standalone /interest-accruals route
// carries the fund selector).
import React from 'react'
import { Typography } from 'antd'
import { FormSection } from '../../../../../core/components/FormSection.tsx'
import InterestAccrualsWorkbench from '../../../../interest_accruals/components/InterestAccrualsWorkbench.tsx'

const { Text } = Typography

interface InterestAccrualsTabProps {
  fundId?: string | null
}

export default function InterestAccrualsTab({ fundId }: InterestAccrualsTabProps) {
  return (
    <div className='h-full overflow-y-auto p-3 flex flex-col gap-3'>
      <FormSection title='Interest Accruals' titleColor='orange'>
        {fundId ? (
          <InterestAccrualsWorkbench fundId={fundId} />
        ) : (
          <Text type='secondary'>Save the fund first to accrue interest.</Text>
        )}
      </FormSection>
    </div>
  )
}
